import { format } from "date-fns";

const ltDateFormatter = new Intl.DateTimeFormat("lt-LT", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

const ltDateTimeFormatter = new Intl.DateTimeFormat("lt-LT", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

export function formatLt(value?: string | null) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";

  return ltDateFormatter.format(d);
}

export function formatLtDateTime(value?: string | null) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";

  return ltDateTimeFormatter.format(d).replace(",", "");
}

export function formatIsoDate(value?: string | null) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";

  return format(d, "yyyy-MM-dd");
}

export function formatReportingPeriod(year: number, month: number): string {
  return `${year}-${String(month).padStart(2, "0")}`;
}
